import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Utilities_ds_transaction_types_ddService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { application_name?: string, full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, transaction_type?: string }[], totalCount?: number }> {
    let url = `${environment.backendUrl}api/Utilities/datasources/ds_transaction_types_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { application_name?: string, full_text_search?: string, $keys: string[] }): Promise<{ result?: { id?: string, transaction_type?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Utilities/datasources/ds_transaction_types_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      application_name?: string, full_text_search?: string    }) {
      return false;
    }
}
